var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2093_854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.457 2.37459C13.665 2.16666 13.9118 2.00173 14.1835 1.8892C14.4551 1.77667 14.7463 1.71875 15.0404 1.71875C15.3344 1.71875 15.6256 1.77667 15.8973 1.8892C16.1689 2.00173 16.4158 2.16666 16.6237 2.37459C16.8316 2.58251 16.9966 2.82936 17.1091 3.10103C17.2216 3.3727 17.2795 3.66387 17.2795 3.95792C17.2795 4.25197 17.2216 4.54315 17.1091 4.81482C16.9966 5.08648 16.8316 5.33333 16.6237 5.54126L5.9362 16.2288L1.58203 17.4163L2.76953 13.0621L13.457 2.37459Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2093_854"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit2);
export default __webpack_public_path__ + "static/media/edit-2.0cddaff2177a01150d940a9c605a6c2d.svg";
export { ForwardRef as ReactComponent };